module.exports = __webpack_public_path__ + "img/lift.a2cd856e.svg";